import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../styles/MaterialNetwork.css"; // Import the CSS file
import Footer from "../FooterBn";

const SiteGuidelines = () => {
  return (
    <>
      <section className="material-network-section">
        <div className="material-container">
          <h1>Resource Network</h1>

          <p>
            These are the official guidelines ("Site Guidelines") for Goatt (
            <a
              href="https://www.goatteachers.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.goatteachers.com
            </a>
            ), Bangladesh’s first complete student solution network. Goatt is
            operated by Goat Technologies Ltd. ("Goatt," "we," "us," or "our").
            These guidelines are part of our Terms of Use and represent our
            shared values of collaboration, access, and transparency for all
            students.
          </p>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SiteGuidelines;
